import * as React from "react";
import "../../poliza.scss";
import PolizaEndorsementForm from "../../../polizaEndorsements/PolizaEndorsementForm";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import IndexPolizaEndorsements from "../../../polizaEndorsements/IndexPolizaEndorsements";
import { generateDefaultPoliza } from "../../utils";

var EndorsementInformation = function EndorsementInformation(props) {
  var poliza = props.poliza,
      endorsement_types = props.endorsement_types,
      companies = props.companies,
      cancel_reasons = props.cancel_reasons,
      regions = props.regions,
      communes = props.communes,
      _props$banks = props.banks,
      banks = _props$banks === void 0 ? [] : _props$banks,
      itemAsegurados = props.itemAsegurados,
      beneficiario = props.beneficiario,
      contratante = props.contratante,
      asegurado = props.asegurado,
      payment_information = props.payment_information,
      commission = props.commission,
      admin = props.admin,
      _props$insurance_brok = props.insurance_broker_agents,
      insurance_broker_agents = _props$insurance_brok === void 0 ? [] : _props$insurance_brok;
  var defaultPoliza = generateDefaultPoliza({
    poliza: poliza,
    itemAsegurados: itemAsegurados,
    beneficiario: beneficiario,
    contratante: contratante,
    asegurado: asegurado,
    payment_information: payment_information,
    commission: commission
  });
  var queryClient = new QueryClient();
  var hasCreatePermission = admin.is_super_admin || admin.permissions_code.includes("poliza_endorsement_create");
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(QueryClientProvider, {
    client: queryClient
  }, hasCreatePermission && /*#__PURE__*/React.createElement(PolizaEndorsementForm, {
    companies: companies,
    polizaEndorsement: {
      poliza_id: poliza.id
    },
    poliza: defaultPoliza,
    endorsement_types: endorsement_types,
    cancel_reasons: cancel_reasons,
    regions: regions,
    communes: communes,
    banks: banks,
    insuranceBrokerAgents: insurance_broker_agents
  }), /*#__PURE__*/React.createElement(IndexPolizaEndorsements, {
    poliza_id: poliza.id,
    admin: admin
  })));
};

export default EndorsementInformation;